import { TabsType } from '@app/utils/types';
import { MembershipStatus } from '@data';
import nl from 'date-fns/locale/nl';
import en from 'date-fns/locale/en-US';
import { Language } from '../enums';

/** Non-empty sentinel for shadcn/Base UI Select "All" options — empty string breaks `data-filled` on the trigger. */
export const SELECT_FILTER_ALL_SENTINEL = '__all__';

export const daysInSprint = 14;
/**
 * How far back "To report" looks when there are no sprints to go on. The window is normally this sprint
 * and the one before it — see `useReportingWindow` — and this is only the fallback.
 */
export const overviewDays = 30;
/**
 * What one working day owes. Everyone files eight hours for every working day, whatever their contract says:
 * somebody who works part time reports the days they did not work against a non-working product. One number,
 * so there is one way to say how much a day owes.
 */
export const HOURS_PER_WORKING_DAY = 8;
/** The same figure in minutes, which is what a day's reports are summed in. */
export const FULL_WORKDAY_MINUTES = HOURS_PER_WORKING_DAY * 60;
export const tabs = {
  currentSprint: TabsType.currentSprint,
  pastSprints: TabsType.pastSprints,
  overview: TabsType.overview,
};

export const membershipTabs = [MembershipStatus.active, MembershipStatus.deactivated];

export const dateFnsLocaleMap: Record<Language, Locale> = {
  [Language.English]: en,
  [Language.Dutch]: nl,
};
